import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import ProductServices from "../../../services/ProductServices";
import RequisitionForm from "../Requisition/RequisitionNumberModal";
import AddMrvForm from "./AddMrvForm";
import CategoryServices from "../../../services/CategoryServices";
import Swal from 'sweetalert2';

const Orders = ({ onSuccess }) => {
  // Part numbers allowed to receive more than approved qty
  const ALLOWED_EXCESS_PARTS = [
    '20634', '20635', '20636', '20637', '20638',
    '20639', '21766', '23470', '23471', '23472'
  ];

  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState();
  const [selectedSupplier, setSelectedSupplier] = useState('');

  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [mrv, setMrv] = useState([]);
  const [selectedMrv, setSelectedMrv] = useState([]);
  const [run, setRun] = useState(0);

  const [items, setItems] = useState([
    {
      name: "",
      id: "",
      description: "",
      approveQty: 0,
      qtyRequired: 0,
      recivedQty: "",
      damageQty: 0,
      error: "",
      unit: "",
      remark: "",
      billUnitAtReceipt: "",
      billUnitSameAsInventory: true,

      rateAtReceipt: 0,

      cgstAtReceipt: 0,
      sgstAtReceipt: 0,
      igstAtReceipt: 0,

      cgstAmountAtReceipt: 0,
      sgstAmountAtReceipt: 0,
      igstAmountAtReceipt: 0,

      amountWithGSTAtReceipt: 0,
    },
  ]);
  const [partOptions, setPartOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  // ======================================
  // FETCH UNIT MASTER
  // ======================================
  useEffect(() => {

    const fetchUnits = async () => {

      try {

        const response =
          await CategoryServices.getUnit();

        const units =
          response?.data?.data || [];
        const options =
          units.map((unit) => ({
            // ObjectId will be submitted
            value:
              unit?._id || "",

            // Name is only for display
            label:
              String(
                unit?.name || "N/A"
              ).trim(),

            unitName:
              String(
                unit?.name || ""
              ).trim()
          }));

        setUnitOptions(options);

      } catch (error) {

        console.error(
          "Unable to load unit master:",
          error
        );

        setUnitOptions([]);

      }

    };

    fetchUnits();

  }, []);

  const handleAddItem = (e) => {
    e.preventDefault();

    const lastItem =
      items[items.length - 1];

    // ======================================
    // VALIDATE CURRENT ROW BEFORE
    // ADDING NEXT ROW
    // ======================================
    if (!lastItem) {
      return;
    }

    // ======================================
    // ITEM REQUIRED
    // ======================================
    if (
      !lastItem.id ||
      !lastItem.name
    ) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Item",
        text: "Please select an item before adding the next row.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // RECEIVED QTY REQUIRED
    // ======================================
    if (
      lastItem.recivedQty === "" ||
      lastItem.recivedQty === undefined ||
      lastItem.recivedQty === null ||
      !Number.isFinite(
        Number(lastItem.recivedQty)
      ) ||
      Number(lastItem.recivedQty) <= 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Item",
        text: "Please enter a valid Received Qty before adding the next row.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // RECEIVED QTY ERROR
    // ======================================
    if (lastItem.error) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Quantity",
        text: lastItem.error,
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // PO TYPE CHECK
    // ======================================
    const isFOCPO =
      lastItem.poType === "FOC PO";

    // ======================================
    // RATE REQUIRED
    // ======================================
    if (
      lastItem.rateAtReceipt === "" ||
      lastItem.rateAtReceipt === undefined ||
      lastItem.rateAtReceipt === null
    ) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Item",
        text: "Please enter Rate before adding the next row.",
        confirmButtonText: "OK",
      });

      return;
    }

    const rateAtReceipt =
      Number(
        lastItem.rateAtReceipt
      );

    if (
      !Number.isFinite(rateAtReceipt) ||
      rateAtReceipt < 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Rate",
        text: "Please enter a valid Rate before adding the next row.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // NORMAL PO -> RATE MUST BE > 0
    // ======================================
    if (
      !isFOCPO &&
      rateAtReceipt <= 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Rate",
        text: "Rate must be greater than 0 for Normal PO.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // FOC PO -> RATE MUST BE 0
    // ======================================
    if (
      isFOCPO &&
      rateAtReceipt !== 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid FOC Rate",
        text: "Rate must be 0 for FOC PO.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // GST AMOUNT FIELDS REQUIRED
    // ======================================
    const requiredAmountFields = [
      {
        key: "cgstAmountAtReceipt",
        label: "CGST Amount",
      },
      {
        key: "sgstAmountAtReceipt",
        label: "SGST Amount",
      },
      {
        key: "igstAmountAtReceipt",
        label: "IGST Amount",
      },
      {
        key: "amountWithGSTAtReceipt",
        label: "Amount with GST",
      },
    ];

    const missingField =
      requiredAmountFields.find(
        ({ key }) =>
          lastItem[key] === "" ||
          lastItem[key] === undefined ||
          lastItem[key] === null
      );

    if (missingField) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Item",
        text:
          `${missingField.label} is required. Enter 0 if it is not applicable.`,
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // CONVERT AMOUNTS
    // ======================================
    const cgstAmount =
      Number(
        lastItem.cgstAmountAtReceipt
      );

    const sgstAmount =
      Number(
        lastItem.sgstAmountAtReceipt
      );

    const igstAmount =
      Number(
        lastItem.igstAmountAtReceipt
      );

    const amountWithGST =
      Number(
        lastItem.amountWithGSTAtReceipt
      );

    // ======================================
    // VALID NUMBER CHECK
    // ======================================
    if (
      !Number.isFinite(cgstAmount) ||
      !Number.isFinite(sgstAmount) ||
      !Number.isFinite(igstAmount) ||
      !Number.isFinite(amountWithGST)
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Billing Amount",
        text: "Please enter valid billing amounts before adding the next row.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // NEGATIVE AMOUNTS NOT ALLOWED
    // ======================================
    if (
      cgstAmount < 0 ||
      sgstAmount < 0 ||
      igstAmount < 0 ||
      amountWithGST < 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Billing Amount",
        text: "Billing amounts cannot be negative.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // NORMAL PO -> GST CANNOT ALL BE ZERO
    // ======================================
    if (
      !isFOCPO &&
      cgstAmount === 0 &&
      sgstAmount === 0 &&
      igstAmount === 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "GST Amount Required",
        text:
          "For Normal PO, enter either CGST + SGST amounts or IGST amount.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // NORMAL PO -> TOTAL MUST BE > 0
    // ======================================
    if (
      !isFOCPO &&
      amountWithGST <= 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Amount",
        text:
          "Amount with GST must be greater than 0 for Normal PO.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // IGST CANNOT BE WITH CGST / SGST
    // ======================================
    if (
      igstAmount > 0 &&
      (
        cgstAmount > 0 ||
        sgstAmount > 0
      )
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid GST",
        text:
          "Enter either IGST or CGST and SGST, not both.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // CGST + SGST MUST BE TOGETHER
    // ======================================
    if (
      (
        cgstAmount > 0 &&
        sgstAmount === 0
      ) ||
      (
        sgstAmount > 0 &&
        cgstAmount === 0
      )
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid GST",
        text:
          "Enter both CGST and SGST amounts, or use IGST.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // CGST + SGST MUST BE EQUAL
    // ======================================
    if (
      cgstAmount > 0 &&
      sgstAmount > 0 &&
      Number(cgstAmount.toFixed(2)) !==
      Number(sgstAmount.toFixed(2))
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid GST",
        text:
          "CGST and SGST amounts must be equal.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // FOC PO -> ALL AMOUNTS MUST BE ZERO
    // ======================================
    if (
      isFOCPO &&
      (
        rateAtReceipt !== 0 ||
        cgstAmount !== 0 ||
        sgstAmount !== 0 ||
        igstAmount !== 0 ||
        amountWithGST !== 0
      )
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid FOC Values",
        text:
          "For FOC PO, Rate, CGST, SGST, IGST and Amount with GST must all be 0.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // REMARK REQUIRED
    // ======================================
    if (
      !lastItem.remark ||
      lastItem.remark.trim() === ""
    ) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Item",
        text:
          "Please enter Remark before adding the next row.",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // ALL VALID -> ADD NEXT ROW
    // ======================================
    setItems([
      ...items,
      {
        name: "",
        id: "",
        description: "",
        approveQty: 0,
        qtyRequired: 0,
        recivedQty: "",
        damageQty: 0,
        error: "",
        unit: "",
        remark: "",
        billUnitAtReceipt: "",
        billUnitSameAsInventory: true,

        rateAtReceipt: "",

        cgstAtReceipt: 0,
        sgstAtReceipt: 0,
        igstAtReceipt: 0,

        cgstAmountAtReceipt: "",
        sgstAmountAtReceipt: "",
        igstAmountAtReceipt: "",

        amountWithGSTAtReceipt: "",

        poNumber: "",
        poType: "",
        supplierName: "",
      },
    ]);
  };

  const handleItemChange = (
    index,
    field,
    value
  ) => {
    const newItems = [...items];

    /*
     * Damage quantity is currently disabled.
     * Always keep it zero.
     */
    if (field === "damageQty") {
      newItems[index].damageQty = 0;

      setItems(newItems);

      return;
    }

    const numericFields = [
      "recivedQty",
      "rateAtReceipt",

      "cgstAmountAtReceipt",
      "sgstAmountAtReceipt",
      "igstAmountAtReceipt",

      "amountWithGSTAtReceipt",
    ];

    // ======================================
    // NEGATIVE VALUE BLOCK
    //
    // Rate / GST amounts / Total amount
    // cannot be negative.
    // ======================================
    const nonNegativeFields = [
      "rateAtReceipt",
      "cgstAmountAtReceipt",
      "sgstAmountAtReceipt",
      "igstAmountAtReceipt",
      "amountWithGSTAtReceipt",
    ];

    if (
      nonNegativeFields.includes(field) &&
      value !== "" &&
      Number(value) < 0
    ) {
      return;
    }

    const finalValue =
      numericFields.includes(field)
        ? value === ""
          ? ""
          : Number(value)
        : value;

    newItems[index][field] =
      finalValue;

    // ======================================
    // GST AMOUNT SYNC + MUTUAL EXCLUSION
    // ======================================

    /*
     * CGST and SGST must always be equal.
     *
     * If user types in either CGST or SGST:
     * - copy same value to both
     * - clear IGST
     *
     * If user deletes either:
     * - clear both CGST and SGST
     * - IGST becomes available again
     */
    if (
      field === "cgstAmountAtReceipt" ||
      field === "sgstAmountAtReceipt"
    ) {

      if (finalValue === "") {

        newItems[index]
          .cgstAmountAtReceipt = "";

        newItems[index]
          .sgstAmountAtReceipt = "";

      } else {

        newItems[index]
          .cgstAmountAtReceipt =
          finalValue;

        newItems[index]
          .sgstAmountAtReceipt =
          finalValue;

        if (
          Number(finalValue) > 0
        ) {
          newItems[index]
            .igstAmountAtReceipt = 0;
        }
      }
    }


    /*
     * When IGST amount is entered:
     * - clear CGST
     * - clear SGST
     *
     * When IGST is deleted:
     * - CGST and SGST become available again
     */
    if (
      field ===
      "igstAmountAtReceipt"
    ) {

      if (
        finalValue !== "" &&
        Number(finalValue) > 0
      ) {

        newItems[index]
          .cgstAmountAtReceipt = 0;

        newItems[index]
          .sgstAmountAtReceipt = 0;
      }
    }

    // ======================================
    // RECEIVED QUANTITY VALIDATION
    // ======================================
    if (field === "recivedQty") {
      const partNo =
        newItems[index]
          .partNo
          ?.toString();

      const approveQty =
        Number(
          newItems[index]
            .approveQty || 0
        );

      /*
       * Damage is disabled and must
       * always remain zero.
       */
      newItems[index].damageQty = 0;

      let maxEligibleQty =
        approveQty;

      if (
        ALLOWED_EXCESS_PARTS.includes(
          partNo
        )
      ) {
        maxEligibleQty =
          approveQty +
          approveQty * 0.05;
      }

      if (finalValue === "") {
        newItems[index].error =
          "Received Qty is required.";
      } else if (
        !Number.isFinite(
          Number(finalValue)
        )
      ) {
        newItems[index].error =
          "Received Qty must be a valid number.";
      } else if (
        Number(finalValue) <= 0
      ) {
        newItems[index].error =
          "Received Qty must be greater than 0.";
      } else if (
        Number(finalValue) >
        maxEligibleQty
      ) {
        newItems[index].error =
          `Received Qty cannot exceed ${maxEligibleQty.toFixed(2)} for this item.`;
      } else {
        newItems[index].error = "";
      }
    }

    setItems(newItems);
  };

  const handlePartSelect = async (
    index,
    selectedOption
  ) => {
    if (!selectedOption) {
      return;
    }

    // ======================================
    // 1. DUPLICATE ITEM VALIDATION
    // ======================================

    const isDuplicate = items.some(
      (item, itemIndex) =>
        itemIndex !== index &&
        item.id === selectedOption.value
    );

    if (isDuplicate) {
      Swal.fire({
        icon: "error",
        title: "Duplicate Item",
        text: "This item has already been added.",
        confirmButtonText: "OK"
      });

      return;
    }

    // ======================================
    // 2. GET EXISTING PO + SUPPLIER DETAILS
    // Exclude the current row
    // ======================================

    const existingPOData = items
      .filter(
        (item, itemIndex) =>
          itemIndex !== index &&
          item.id &&
          item.poNumber !== undefined &&
          item.poNumber !== null &&
          item.poNumber !== ""
      )
      .map((item) => ({
        poNumber: String(item.poNumber),
        supplierName:
          item.supplierName || "N/A"
      }));

    const existingPONumbers = [
      ...new Set(
        existingPOData.map(
          (item) => item.poNumber
        )
      )
    ];

    const selectedPONumber =
      selectedOption.poNumber !== undefined &&
        selectedOption.poNumber !== null
        ? String(selectedOption.poNumber)
        : "";

    const selectedSupplierName =
      selectedOption.supplierName ||
      "N/A";

    // ======================================
    // 3. DIFFERENT PO CONFIRMATION
    // ======================================

    const isDifferentPO =
      existingPONumbers.length > 0 &&
      selectedPONumber &&
      !existingPONumbers.includes(
        selectedPONumber
      );

    if (isDifferentPO) {
      const existingDetailsHtml = [
        ...new Map(
          existingPOData.map((item) => [
            `${item.poNumber}-${item.supplierName}`,
            item
          ])
        ).values()
      ]
        .map(
          (item) => `
        <div style="
          border:1px solid #dee2e6;
          border-radius:6px;
          padding:8px 10px;
          margin-bottom:6px;
          background:#f8f9fa;
        ">
          <div>
            <strong>PO No.:</strong>
            ${item.poNumber}
          </div>

          <div>
            <strong>Supplier:</strong>
            ${item.supplierName}
          </div>
        </div>
      `
        )
        .join("");

      const result = await Swal.fire({
        icon: "warning",
        title: "Different PO Selected",

        html: `
        <div style="text-align:left">

          <p style="margin-bottom:6px">
            <strong>Existing selected item:</strong>
          </p>

          ${existingDetailsHtml}

          <p style="margin-top:14px; margin-bottom:6px">
            <strong>New selected item:</strong>
          </p>

          <div style="
            border:1px solid #ffc107;
            border-radius:6px;
            padding:8px 10px;
            background:#fff8e1;
          ">
            <div>
              <strong>PO No.:</strong>
              ${selectedPONumber || "N/A"}
            </div>

            <div>
              <strong>Supplier:</strong>
              ${selectedSupplierName}
            </div>
          </div>

          <p style="margin-top:14px; margin-bottom:0">
            Do you want to add this item from a different PO?
          </p>

        </div>
      `,

        showCancelButton: true,

        confirmButtonText:
          "Yes, Continue",

        cancelButtonText:
          "Cancel",

        reverseButtons: true,
        focusCancel: true
      });

      if (!result.isConfirmed) {
        return;
      }
    }

    // ======================================
    // 4. APPLY SELECTED ITEM TO ROW
    // ======================================

    setItems((previousItems) =>
      previousItems.map(
        (item, itemIndex) => {

          if (itemIndex !== index) {
            return item;
          }

          const inventoryUnit =
            selectedOption.unit || "";

          const inventoryUnitId =
            selectedOption.inventoryUnitId || "";
          return {
            ...item,

            id:
              selectedOption.value,

            partNo:
              selectedOption.partNo,

            name:
              selectedOption.label,

            approveQty:
              selectedOption.approveQty,

            qtyRequired:
              selectedOption.qtyRequired,

            description:
              selectedOption.description,

            // ======================================
            // INVENTORY UNIT
            // ======================================
            unit:
              inventoryUnit,

            inventoryUnitId:
              inventoryUnitId,

            poNumber:
              selectedOption.poNumber,

            poType:
              selectedOption.poType,

            supplierName:
              selectedOption.supplierName,

            recivedQty: "",
            damageQty: 0,
            error: "",
            remark: "",

            // ======================================
            // BILL UNIT
            //
            // DEFAULT:
            // SAME AS INVENTORY UNIT
            // ======================================
            billUnitAtReceipt:
              inventoryUnitId,

            billUnitSameAsInventory:
              true,

            rateAtReceipt: 0,

            cgstAtReceipt: 0,
            sgstAtReceipt: 0,
            igstAtReceipt: 0,

            cgstAmountAtReceipt: 0,
            sgstAmountAtReceipt: 0,
            igstAmountAtReceipt: 0,

            amountWithGSTAtReceipt: 0
          };
        }
      )
    );
  };

  const handleRemoveItem = (e, index) => {
    e.preventDefault();
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };

  useEffect(() => {
    if (!selectedStore) return;

    setItems([{
      name: "",
      id: "",
      description: "",
      approveQty: 0,
      qtyRequired: 0,
      recivedQty: "",
      damageQty: 0,
      error: "",
      unit: "",
      remark: "",
      billUnitAtReceipt: "",
      billUnitSameAsInventory: true,
      rateAtReceipt: 0,

      cgstAtReceipt: 0,
      sgstAtReceipt: 0,
      igstAtReceipt: 0,

      cgstAmountAtReceipt: 0,
      sgstAmountAtReceipt: 0,
      igstAmountAtReceipt: 0,

      amountWithGSTAtReceipt: 0
    }]);

    RequestServies.getMrv(selectedStore)
      .then((res) => {
        const allMrv = res?.data?.data || [];

        const supplierMrv = allMrv.filter(mrv =>
          mrv.supplier &&
          !mrv.supplier?.name?.toLowerCase().startsWith("local")
        );

        setMrv(supplierMrv);

        if (supplierMrv.length > 0) {
          setSelectedMrv(supplierMrv[0]._id);
          setSelectedSupplier(supplierMrv[0]?.supplier?._id);
        } else {
          // ✅ IMPORTANT: no MRV → no supplier → no items
          setSelectedMrv("");
          setSelectedSupplier("");
          setPartOptions([]);
        }
      })
      .catch(console.log);
  }, [selectedStore, run]);


  useEffect(() => {
    // ✅ HARD BLOCK when MRV or Supplier missing
    if (!selectedStore || !selectedSupplier || !selectedMrv) {
      setPartOptions([]);
      return;
    }

    const status = 'approved';
    const poStatus = 'generated';

    RequestServies.getAllItem(undefined, status, selectedStore, poStatus)
      .then((res) => {
        const filtered = res?.data?.data?.filter(
          part => part?.po?.items?.[0]?.supplier?._id === selectedSupplier
        );

        const options = filtered.map((part) => ({
          value: part?._id,
          label: `${part?.inventory?.masterItem?.partNo} | ${part?.inventory?.masterItem?.description}`,
          approveQty: part?.approveQty,
          description: part?.inventory?.masterItem?.description,
          qtyRequired: part?.qtyRequired,
          unit:
            part?.inventory?.masterItem?.unit?.name,

          inventoryUnitId:
            part?.inventory?.masterItem?.unit?._id || "",
          poNumber:
            part?.po?.poNumber,
          poType: part?.po?.poType,          // ✅ NEW
          supplierName: part?.po?.items?.[0]?.supplier?.name,
          partNo: part?.inventory?.masterItem?.partNo,
        }));

        setPartOptions(options);
      })
      .catch(console.log);
  }, [selectedStore, selectedSupplier, selectedMrv, run]);


  const handleSubmit = (e) => {
    e.preventDefault();

    let isValid = true;
    let errorMessage = "";

    // ======================================
    // PREVENT DUPLICATE ITEMS
    // ======================================
    const uniqueIds = new Set();

    for (const item of items) {
      if (!item.id) {
        isValid = false;
        errorMessage =
          "Please select an item.";
        break;
      }

      if (uniqueIds.has(item.id)) {
        isValid = false;

        errorMessage =
          `Duplicate item detected: ${item.name || item.id}`;

        break;
      }

      uniqueIds.add(item.id);
    }

    // ======================================
    // VALIDATE ITEMS
    // ======================================
    if (isValid) {
      for (
        let index = 0;
        index < items.length;
        index++
      ) {
        const item = items[index];

        const approveQty = Number(
          item.approveQty || 0
        );

        const receivedQty = Number(
          item.recivedQty
        );

        const partNo =
          item.partNo?.toString();

        const isFOCPO =
          item.poType === "FOC PO";

        let maxEligibleQty =
          approveQty;

        // Selected parts can be received
        // up to 5% above approved quantity.
        if (
          ALLOWED_EXCESS_PARTS.includes(
            partNo
          )
        ) {
          maxEligibleQty =
            approveQty +
            approveQty * 0.05;
        }

        // ====================================
        // 1. ITEM REQUIRED
        // ====================================
        if (!item.id) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Please select an item.`;

          break;
        }

        // ====================================
        // 2. RECEIVED QTY REQUIRED
        // ====================================
        if (
          item.recivedQty === "" ||
          item.recivedQty === undefined ||
          item.recivedQty === null ||
          !Number.isFinite(receivedQty)
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Please enter a valid Received Qty.`;

          break;
        }

        // ====================================
        // 3. RECEIVED QTY MUST BE POSITIVE
        // ====================================
        if (receivedQty <= 0) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Received Qty must be greater than 0.`;

          break;
        }

        // ====================================
        // 4. RECEIVED QTY LIMIT
        // ====================================
        if (
          receivedQty >
          maxEligibleQty
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1} (${partNo || "-"}): Received Qty (${receivedQty}) cannot exceed ${maxEligibleQty.toFixed(2)}.`;

          break;
        }

        // ====================================
        // 5. MRV REQUIRED
        // ====================================
        if (!selectedMrv) {
          isValid = false;
          errorMessage = "MRV Not Selected!";
          break;
        }

        // ====================================
        // BILL UNIT REQUIRED
        // ====================================
        if (
          !item.billUnitAtReceipt ||
          String(item.billUnitAtReceipt).trim() === ""
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Bill Unit is required.`;

          break;
        }

        // ====================================
        // 6. REMARK REQUIRED
        // ====================================
        if (
          !item.remark ||
          item.remark.trim() === ""
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Remark is required.`;

          break;
        }

        // ====================================
        // 7. RATE REQUIRED
        // ====================================
        if (
          item.rateAtReceipt === "" ||
          item.rateAtReceipt === undefined ||
          item.rateAtReceipt === null
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Rate is required.`;

          break;
        }

        const rateAtReceipt = Number(
          item.rateAtReceipt
        );

        if (
          !Number.isFinite(rateAtReceipt) ||
          rateAtReceipt < 0
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Please enter a valid Rate.`;

          break;
        }

        if (
          !isFOCPO &&
          rateAtReceipt <= 0
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Rate must be greater than 0.`;

          break;
        }

        // ====================================
        // 8. ALL FOUR AMOUNT FIELDS REQUIRED
        // ====================================
        const requiredAmountFields = [
          {
            key: "cgstAmountAtReceipt",
            label: "CGST Amount",
          },
          {
            key: "sgstAmountAtReceipt",
            label: "SGST Amount",
          },
          {
            key: "igstAmountAtReceipt",
            label: "IGST Amount",
          },
          {
            key: "amountWithGSTAtReceipt",
            label: "Amount with GST",
          },
        ];

        const missingAmountField =
          requiredAmountFields.find(
            ({ key }) =>
              item[key] === "" ||
              item[key] === undefined ||
              item[key] === null
          );

        if (missingAmountField) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: ${missingAmountField.label} is required. Enter 0 if it is not applicable.`;

          break;
        }

        // ====================================
        // 9. CONVERT AMOUNTS
        // ====================================
        const cgstAmount = Number(
          item.cgstAmountAtReceipt
        );

        const sgstAmount = Number(
          item.sgstAmountAtReceipt
        );

        const igstAmount = Number(
          item.igstAmountAtReceipt
        );

        const amountWithGST = Number(
          item.amountWithGSTAtReceipt
        );

        // ====================================
        // 10. VALID NUMBER CHECK
        // ====================================
        if (
          !Number.isFinite(cgstAmount) ||
          !Number.isFinite(sgstAmount) ||
          !Number.isFinite(igstAmount) ||
          !Number.isFinite(amountWithGST)
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Please enter valid billing amounts.`;

          break;
        }

        // ====================================
        // 11. NEGATIVE AMOUNT CHECK
        // ====================================
        if (
          cgstAmount < 0 ||
          sgstAmount < 0 ||
          igstAmount < 0 ||
          amountWithGST < 0
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Billing amounts cannot be negative.`;

          break;
        }

        // ====================================
        // 12. IGST CANNOT BE WITH CGST/SGST
        // ====================================
        if (
          igstAmount > 0 &&
          (
            cgstAmount > 0 ||
            sgstAmount > 0
          )
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Enter either IGST amount or CGST and SGST amounts, not both.`;

          break;
        }

        // ====================================
        // 13. CGST AND SGST MUST BE TOGETHER
        // ====================================
        if (
          (
            cgstAmount > 0 &&
            sgstAmount === 0
          ) ||
          (
            sgstAmount > 0 &&
            cgstAmount === 0
          )
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Enter both CGST and SGST amounts, or enter 0 in both.`;

          break;
        }

        // ====================================
        // 14. CGST AND SGST MUST BE EQUAL
        // ====================================
        if (
          cgstAmount > 0 &&
          sgstAmount > 0 &&
          Number(cgstAmount.toFixed(2)) !==
          Number(sgstAmount.toFixed(2))
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: CGST and SGST amounts must be equal.`;

          break;
        }

        // ====================================
        // 15. AMOUNT WITH GST REQUIRED
        // ====================================
        if (
          !isFOCPO &&
          amountWithGST <= 0
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Amount with GST must be greater than 0.`;

          break;
        }

        // ====================================
        // 16. AMOUNT WITH GST BASIC CHECK
        // ====================================
        const totalEnteredGST =
          cgstAmount +
          sgstAmount +
          igstAmount;

        if (
          amountWithGST <
          totalEnteredGST
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: Amount with GST cannot be less than the total GST amount.`;

          break;
        }

        // ====================================
        // 17. FOC VALUES MUST BE ZERO
        // ====================================
        if (
          isFOCPO &&
          (
            rateAtReceipt !== 0 ||
            cgstAmount !== 0 ||
            sgstAmount !== 0 ||
            igstAmount !== 0 ||
            amountWithGST !== 0
          )
        ) {
          isValid = false;

          errorMessage =
            `Item ${index + 1}: For FOC PO, Rate and all amounts must be 0.`;

          break;
        }
      }
    }

    // ======================================
    // SHOW VALIDATION ERROR
    // ======================================
    if (!isValid) {
      Swal.fire({
        title: "Error!",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });

      return;
    }

    // ======================================
    // PREPARE REQUEST ITEMS
    // ======================================
    const requestItems =
      items.map((item) => ({
        ...item,

        damageQty: 0,

        recivedQty: Number(
          item.recivedQty
        ),

        approveQty: Number(
          item.approveQty || 0
        ),

        qtyRequired: Number(
          item.qtyRequired || 0
        ),

        billUnitAtReceipt:
          String(
            item.billUnitAtReceipt || ""
          ).trim(),

        rateAtReceipt: Number(
          item.rateAtReceipt || 0
        ),

        // Old percentage fields retained
        // but always submitted as zero
        cgstAtReceipt: 0,
        sgstAtReceipt: 0,
        igstAtReceipt: 0,

        cgstAmountAtReceipt: Number(
          item.cgstAmountAtReceipt
        ),

        sgstAmountAtReceipt: Number(
          item.sgstAmountAtReceipt
        ),

        igstAmountAtReceipt: Number(
          item.igstAmountAtReceipt
        ),

        amountWithGSTAtReceipt: Number(
          item.amountWithGSTAtReceipt
        ),

        remark: String(
          item.remark || ""
        ).trim(),
      }));

    const requestData = {
      mrvId: selectedMrv,
      items: requestItems,
    };

    // ======================================
    // SUBMIT MRV
    // ======================================
    RequestServies
      .submitMrv(requestData)
      .then(() => {
        Swal.fire({
          title: "Success!",
          text:
            "Order has been Received Successfully",
          icon: "success",
          confirmButtonText: "OK",
        });

        setItems([
          {
            name: "",
            id: "",
            description: "",
            approveQty: 0,
            qtyRequired: 0,
            recivedQty: "",
            damageQty: 0,
            error: "",
            unit: "",
            remark: "",
            billUnitAtReceipt: "",
            billUnitSameAsInventory: true,
            rateAtReceipt: "",

            // Old percentage fields
            cgstAtReceipt: 0,
            sgstAtReceipt: 0,
            igstAtReceipt: 0,

            // Required manual fields
            cgstAmountAtReceipt: "",
            sgstAmountAtReceipt: "",
            igstAmountAtReceipt: "",
            amountWithGSTAtReceipt: "",

            poNumber: "",
            poType: "",
            supplierName: "",
          },
        ]);

        setRun(
          (previous) =>
            previous + 1
        );
      })
      .catch((error) => {
        console.error(
          "Error during submission:",
          error
        );

        Swal.fire({
          title: "Error!",
          text:
            error?.response?.data?.message ||
            "Error during submission",
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    setSelectedMrv();
  };

  const handleRequisitionForm = () => {
    setIsModelOpen(true);
  };

  const handleMrv = (selected) => {
    const mrvId = selected?.value || "";
    const supplierId = selected?.supplierId || "";

    console.log("Selected MRV:", mrvId);
    console.log("Selected Supplier:", supplierId);

    setSelectedMrv(mrvId);
    setSelectedSupplier(supplierId);

    // Reset selected item rows when MRV changes
    setItems([
      {
        name: "",
        id: "",
        description: "",
        approveQty: 0,
        qtyRequired: 0,
        recivedQty: "",
        damageQty: 0,
        error: "",
        unit: "",
        remark: "",
        billUnitAtReceipt: "",
        billUnitSameAsInventory: true,
        rateAtReceipt: 0,

        cgstAtReceipt: 0,
        sgstAtReceipt: 0,
        igstAtReceipt: 0,

        cgstAmountAtReceipt: 0,
        sgstAmountAtReceipt: 0,
        igstAmountAtReceipt: 0,

        amountWithGSTAtReceipt: 0,
        poNumber: "",
        poType: "",
        supplierName: ""
      }
    ]);

    setPartOptions([]);
  };

  useEffect(() => {
    setPartOptions([]);
  }, [selectedMrv]);

  return (
    <>
      <AddMrvForm
        show={isModelOpen}
        handleClose={() => setIsModelOpen(false)}
        store={stores}
        onSuccess={() => setRun(prev => prev + 1)}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-4">
                      <label>Select Store</label>

                      <Select
                        className="mb-xl-0 mb-3"
                        options={stores.map((store) => ({
                          value: store._id,
                          label: store.name,
                        }))}
                        value={
                          stores
                            .map((store) => ({
                              value: store._id,
                              label: store.name,
                            }))
                            .find((opt) => opt.value === selectedStore) || null
                        }
                        onChange={(selected) =>
                          handleStoreChange({
                            target: {
                              value: selected ? selected.value : "",
                            },
                          })
                        }
                        placeholder="Search Store..."
                        isSearchable
                      />
                    </div>

                    <div className="col-xl-4">
                      <label>Select MRV No.</label>

                      <Select
                        className="mb-xl-0 mb-3"

                        options={
                          mrv.length > 0
                            ? mrv.map((m) => ({
                              value: m._id,

                              label: `${m.mrvNo} | ${m.supplier?.name || "N/A"} | Bill No: ${m.billingNo || "N/A"
                                }`,

                              // ✅ IMPORTANT
                              supplierId: m.supplier?._id || ""
                            }))
                            : []
                        }

                        value={
                          mrv
                            .map((m) => ({
                              value: m._id,

                              label: `${m.mrvNo} | ${m.supplier?.name || "N/A"} | Bill No: ${m.billingNo || "N/A"
                                }`,

                              supplierId: m.supplier?._id || ""
                            }))
                            .find(
                              (option) =>
                                String(option.value) === String(selectedMrv)
                            ) || null
                        }

                        // ✅ Pass react-select object directly
                        onChange={handleMrv}

                        placeholder="Search MRV No..."
                        noOptionsMessage={() => "No records found"}
                        isSearchable
                      />
                    </div>

                    <div className="col-xl-4 d-flex align-items-end">
                      <button
                        className="btn btn-sm btn-primary w-100"
                        onClick={handleRequisitionForm}
                      >
                        Generate New MRV No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-plus me-2" aria-hidden="true"></i>Add
                MRV Item
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <form>
                        {items.map((item, index) => (
                          <div key={index} className="row">
                            <div className="form-group mb-2 col-md-2">
                              <label>Part Number</label>
                              <Select
                                options={partOptions}

                                value={
                                  item.id
                                    ? partOptions.find(
                                      (option) =>
                                        option.value === item.id
                                    ) || null
                                    : null
                                }

                                onChange={(selectedOption) =>
                                  handlePartSelect(
                                    index,
                                    selectedOption
                                  )
                                }

                                placeholder="Part"

                                menuPortalTarget={
                                  document.body
                                }

                                filterOption={(
                                  option,
                                  inputValue
                                ) =>
                                  option.label
                                    ?.toLowerCase()
                                    .includes(
                                      inputValue.toLowerCase()
                                    )
                                }

                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minWidth: 90,
                                    height: 14,
                                    fontSize: "12px"
                                  }),

                                  valueContainer: (base) => ({
                                    ...base,
                                    height: "100%"
                                  }),

                                  input: (base) => ({
                                    ...base,
                                    height: "auto"
                                  }),

                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999
                                  })
                                }}
                              />
                            </div>


                            <div className="form-group mb-2 col-md-2">
                              <label>Description</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="description"
                                value={item.description}
                                placeholder="Description"
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Required Qty (${item.unit})` : `Required Qty`}
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="qtyRequired"
                                value={item.qtyRequired}
                                placeholder="Required Qty"
                                readOnly
                              />

                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Approved (${item.unit})` : `Approved`}
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="approveQty"
                                value={item.approveQty}
                                placeholder="approveQty"
                                readOnly
                              />
                            </div>

                            <div className="form-group mb-2 col-md-2">
                              <label>
                                {item.unit ? `Received Qty (${item.unit})` : `Received Qty`}
                              </label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="recivedQty"
                                value={item.recivedQty}
                                min="0.01"
                                step="any"
                                onWheel={(event) =>
                                  event.currentTarget.blur()
                                }
                                onFocus={(event) =>
                                  event.target.select()
                                }
                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "recivedQty",
                                    event.target.value
                                  )
                                }
                                placeholder="Enter Received Qty"
                              />
                              {item.error && <p className="text-danger mb-0">{item.error}</p>}
                            </div>
                            <div className="form-group mb-2 col-md-2">

                              <label>
                                {item.unit
                                  ? `Damage (${item.unit})`
                                  : "Damage"}

                                <span
                                  className="text-muted ms-1"
                                  style={{
                                    fontSize: "11px"
                                  }}
                                >
                                  (Disabled)
                                </span>
                              </label>

                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="damageQty"
                                value={0}
                                readOnly
                                disabled
                                tabIndex={-1}
                              />

                            </div>
                            <div className="form-group mb-2 col-md-3">
                              <label>PO Number</label>
                              <input type="text" className="form-control form-control-sm" value={item.poNumber || ''} readOnly />
                            </div>

                            <div className="form-group mb-2 col-md-3">
                              <label>Supplier</label>
                              <input type="text" className="form-control form-control-sm" value={item.supplierName || ''} readOnly />
                            </div>
                            <div className="form-group mb-2 col-md-3">
                              <label>Rate</label>

                              <input
                                type="number"
                                className="form-control form-control-sm"

                                value={
                                  item.rateAtReceipt ?? ""
                                }

                                min="0"
                                step="any"

                                onWheel={(event) =>
                                  event.currentTarget.blur()
                                }

                                onFocus={(event) =>
                                  event.target.select()
                                }

                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "rateAtReceipt",
                                    event.target.value
                                  )
                                }
                              />

                            </div>
                            {/* ==================================
    BILL UNIT
================================== */}
                            <div className="form-group mb-2 col-md-3">

                              <label>Bill Unit</label>

                              {!item.id || !item.unit ? (

                                // Before item selection:
                                // keep normal dropdown visible
                                <Select
                                  options={unitOptions}

                                  value={
                                    item.billUnitAtReceipt
                                      ? unitOptions.find(
                                        (option) =>
                                          String(option.value)
                                            .trim()
                                            .toLowerCase() ===
                                          String(item.billUnitAtReceipt)
                                            .trim()
                                            .toLowerCase()
                                      ) || null
                                      : null
                                  }

                                  onChange={(selectedOption) =>
                                    handleItemChange(
                                      index,
                                      "billUnitAtReceipt",
                                      selectedOption
                                        ? selectedOption.value
                                        : ""
                                    )
                                  }

                                  placeholder="Bill Unit"

                                  isSearchable

                                  menuPortalTarget={document.body}

                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: 31,
                                      fontSize: "12px"
                                    }),

                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999
                                    })
                                  }}
                                />

                              ) : (

                                <>

                                  {/* ==================================
          SAME AS INVENTORY UNIT
      ================================== */}
                                  <div
                                    className="form-check mb-1"
                                    style={{
                                      fontSize: "12px"
                                    }}
                                  >

                                    <input
                                      type="checkbox"
                                      className="form-check-input"

                                      id={`bill-unit-same-${index}`}

                                      checked={
                                        item.billUnitSameAsInventory !== false
                                      }

                                      onChange={(event) => {

                                        const checked =
                                          event.target.checked;

                                        const newItems =
                                          [...items];

                                        newItems[index] = {
                                          ...newItems[index],

                                          billUnitSameAsInventory:
                                            checked,

                                          billUnitAtReceipt:
                                            checked
                                              ? item.inventoryUnitId || ""
                                              : ""
                                        };

                                        setItems(newItems);
                                      }}
                                    />

                                    <label
                                      className="form-check-label"
                                      htmlFor={`bill-unit-same-${index}`}
                                      style={{
                                        cursor: "pointer"
                                      }}
                                    >
                                      Same as Inventory Unit

                                      {item.unit
                                        ? ` (${item.unit})`
                                        : ""}
                                    </label>

                                  </div>


                                  {/* ==================================
          SHOW DROPDOWN ONLY WHEN UNCHECKED
      ================================== */}
                                  {item.billUnitSameAsInventory === false && (

                                    <Select
                                      options={unitOptions}

                                      value={
                                        item.billUnitAtReceipt
                                          ? unitOptions.find(
                                            (option) =>
                                              String(option.value) ===
                                              String(item.billUnitAtReceipt)
                                          ) || null
                                          : null
                                      }

                                      onChange={(selectedOption) => {

                                        const selectedBillUnitId =
                                          selectedOption
                                            ? selectedOption.value
                                            : "";

                                        // ==================================
                                        // SAVE SELECTED BILL UNIT
                                        // ==================================
                                        handleItemChange(
                                          index,
                                          "billUnitAtReceipt",
                                          selectedBillUnitId
                                        );


                                        // ==================================
                                        // CHECK BILL UNIT VS INVENTORY UNIT
                                        // ==================================
                                        if (
                                          selectedBillUnitId &&
                                          item.inventoryUnitId &&
                                          String(selectedBillUnitId) !==
                                          String(item.inventoryUnitId)
                                        ) {

                                          Swal.fire({
                                            icon: "info",

                                            title:
                                              "Different Bill Unit",

                                            html: `
                  <div style="font-size:14px;">

                    Selected Bill Unit
                    <strong>
                      (${selectedOption?.label || "N/A"})
                    </strong>

                    is different from Inventory Unit
                    <strong>
                      (${item.unit || "N/A"})
                    </strong>.

                    <br/><br/>

                    Please change the
                    <strong>Received Qty</strong>
                    accordingly.

                  </div>
                `,

                                            confirmButtonText:
                                              "OK",

                                            timer: 10000,

                                            timerProgressBar: true
                                          });
                                        }
                                      }}

                                      placeholder="Select Bill Unit"

                                      isSearchable

                                      menuPortalTarget={document.body}

                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          minHeight: 31,
                                          fontSize: "12px"
                                        }),

                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999
                                        })
                                      }}
                                    />

                                  )}

                                </>
                              )}

                            </div>

                            {/* ==================================
    CGST AMOUNT
================================== */}
                            <div className="form-group mb-2 col-md-2">
                              <label>CGST Amount</label>

                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="cgstAmountAtReceipt"
                                value={
                                  item.cgstAmountAtReceipt ?? 0
                                }
                                min="0"
                                step="any"
                                required

                                // Disable when IGST is entered
                                disabled={
                                  Number(
                                    item.igstAmountAtReceipt || 0
                                  ) > 0
                                }

                                // Select existing zero when focused
                                onFocus={(event) =>
                                  event.target.select()
                                }

                                onWheel={(event) =>
                                  event.currentTarget.blur()
                                }

                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "cgstAmountAtReceipt",
                                    event.target.value
                                  )
                                }

                                placeholder="Enter CGST Amount"
                              />
                            </div>

                            {/* ==================================
    SGST AMOUNT
================================== */}
                            <div className="form-group mb-2 col-md-2">
                              <label>SGST Amount</label>

                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="sgstAmountAtReceipt"
                                value={
                                  item.sgstAmountAtReceipt ?? 0
                                }
                                min="0"
                                step="any"
                                required

                                // Disable when IGST is entered
                                disabled={
                                  Number(
                                    item.igstAmountAtReceipt || 0
                                  ) > 0
                                }

                                // Select existing zero when focused
                                onFocus={(event) =>
                                  event.target.select()
                                }

                                onWheel={(event) =>
                                  event.currentTarget.blur()
                                }

                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "sgstAmountAtReceipt",
                                    event.target.value
                                  )
                                }

                                placeholder="Enter SGST Amount"
                              />
                            </div>

                            {/* ==================================
    IGST AMOUNT
================================== */}
                            <div className="form-group mb-2 col-md-2">
                              <label>IGST Amount</label>

                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="igstAmountAtReceipt"
                                value={
                                  item.igstAmountAtReceipt ?? 0
                                }
                                min="0"
                                step="any"
                                required

                                // Disable when CGST or SGST is entered
                                disabled={
                                  Number(
                                    item.cgstAmountAtReceipt || 0
                                  ) > 0 ||
                                  Number(
                                    item.sgstAmountAtReceipt || 0
                                  ) > 0
                                }

                                // Select existing zero when focused
                                onFocus={(event) =>
                                  event.target.select()
                                }

                                onWheel={(event) =>
                                  event.currentTarget.blur()
                                }

                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "igstAmountAtReceipt",
                                    event.target.value
                                  )
                                }

                                placeholder="Enter IGST Amount"
                              />
                            </div>

                            {/* ==================================
    AMOUNT WITH GST
================================== */}
                            <div className="form-group mb-2 col-md-2">
                              <label>Item Amount with GST</label>

                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="amountWithGSTAtReceipt"
                                value={
                                  item.amountWithGSTAtReceipt ?? 0
                                }
                                min="0"
                                step="any"
                                required

                                // Select existing zero when focused
                                onFocus={(event) =>
                                  event.target.select()
                                }

                                onWheel={(event) =>
                                  event.currentTarget.blur()
                                }

                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "amountWithGSTAtReceipt",
                                    event.target.value
                                  )
                                }

                                placeholder="Enter Amount with GST"
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="remark"
                                value={item.remark}
                                onChange={(event) =>
                                  handleItemChange(index, "remark", event.target.value)
                                }
                                placeholder="Remark"
                              />
                            </div>


                            {/* ==================================
    DELETE ITEM
================================== */}
                            <div
                              className="
    form-group
    mb-2
    col-md-1
    d-flex
    align-items-center
    justify-content-center
  "
                              style={{
                                paddingTop: "24px",
                              }}
                            >
                              <button
                                type="button"
                                className="btn btn-danger btn-xs sharp"
                                onClick={(event) =>
                                  handleRemoveItem(
                                    event,
                                    index
                                  )
                                }
                                title="Remove Item"
                              >
                                <i className="fa fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        ))}
                        <div className="row">
                          <div className="form-group mb-2 col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={(e) => handleAddItem(e)}
                            >
                              Add Item
                            </button>
                          </div>

                          <div className="form-group mb-2 col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default Orders;
